import styled from 'styled-components'

export const ModalTextContainer = styled.div`
  line-height: 32px;
  font-size: 1.2rem;
  text-align: center;
`

export const ModalInputsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  width: 100%;
`

export const ModalLabel = styled.p`
  color: var(--color-primary-01);
  padding-bottom: 16px;
`

export const ModalInputWrapper = styled.div`
  & + & {
    margin-left: 32px;
  }

  input {
    width: 100px;
  }

  input:disabled {
    cursor: not-allowed;
  }
`
